import API_BASE from "@/config/api";

export const API_URL = API_BASE;
